import React, { FC } from "react";
import { t } from "i18next";
import { ICON_NAMES } from "utils/constant";
import { Comment } from "../utils";

interface HeadComment extends Comment {
	inEdit?: boolean;
}

interface StepThreeMobileListProps {
	comments: HeadComment[];
	onDescriptionChange: (id: number, description: string) => void;
	onDescriptionBlur: (id: number, description: string) => void;
	onDelete: (line: HeadComment) => void;
}

const StepThreeMobileList: FC<StepThreeMobileListProps> = ({
	comments,
	onDescriptionChange,
	onDescriptionBlur,
	onDelete,
}) => {
	if (!comments.length) {
		return null;
	}

	return (
		<div className="landing-note-step3-list">
			{comments.map((line) => (
				<div className="landing-note-step3-row" key={line.id}>
					<div className="landing-note-step3-line-number">{line.lineNumber}</div>
					<textarea
						className="landing-note-step3-textarea"
						value={line.description || ""}
						onChange={(e) => onDescriptionChange(line.id, e.target.value)}
						onBlur={(e) => onDescriptionBlur(line.id, e.target.value)}
						placeholder="Notat"
						rows={2}
					/>
					<button
						type="button"
						className="landing-note-step3-delete"
						onClick={() => onDelete(line)}
						aria-label={t("DeleteLine")}
						title={t("DeleteLine")}
					>
						<img src={`/icon/${ICON_NAMES.Delete}.svg`} alt={t("DeleteLine")} />
					</button>
				</div>
			))}
		</div>
	);
};

export default StepThreeMobileList;
